import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

export enum ToastType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export interface Toast {
  id: number
  message: string
  type: ToastType
  notifyTime: number
  visible: boolean
  progress: number
}

const defaultNotifyTime: Record<ToastType, number> = {
  [ToastType.Success]: 3000,
  [ToastType.Info]: 5000,
  [ToastType.Warning]: 5000,
  [ToastType.Error]: 7000,
}

let nextId = 1

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([])

  function notify (message: string, type: ToastType = ToastType.Info, notifyTime: number = defaultNotifyTime[type]) {
    const toast = reactive<Toast>({
      id: nextId++,
      message,
      type,
      notifyTime,
      visible: true,
      progress: 0,
    })
    toasts.value.push(toast)
    startProgress(toast)
  }

  function removeNotification (toast: Toast) {
    toasts.value = toasts.value.filter(t => t.id !== toast.id)
  }

  function startProgress (toast: Toast) {
    const start = Date.now()
    const duration = toast.notifyTime || 3000

    const interval = setInterval(() => {
      const elapsed = Date.now() - start
      toast.progress = Math.min((elapsed / duration) * 100, 100)
      if (toast.progress >= 100 || !toast.visible) {
        clearInterval(interval)
      }
    }, 100)
  }

  return {
    toasts,
    notify,
    removeNotification,
  }
})
